export const SliderItemTest = {
	name: "SliderItemTest",
	render(h) {
		var row = h('div', { class: ["test"] }, []);
		//Vue get line-breaks as Vnode, this will remove them
		var slots = this.$slots.default.filter(slot => slot.tag);

		//Get array of Vnodes
		var items = slots.reduce((acc, cur, index) => {
			row.children.push(cur);

			//Group slots 2by2 in a div.test, or if last items are "alone"
			if ((index + 1) % 6 == 0 || slots.length - 1 == index) {
				acc.push(row);
				row = h('div', { class: ["test"] }, []);
			}

			return acc;
		}, []);

		this.$parent.$emit('update-data', items.length, 2);

		return h(
			'div',
			{ class: ['test-mat'] },
			[items]
		)
	}
}
